export const getColumnWidth = (tableName, columnKey) => {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${tableName}=`));

  if (!cookie) return null;

  try {
    const value = decodeURIComponent(cookie.split("=")[1]);
    const tableData = JSON.parse(value);
    return tableData[columnKey] ?? null;
  } catch (err) {
    console.error("Error parsing cookie data:", err);
    return null;
  }
};

export const setColumnWidth = (tableName, columnKey, width) => {
  // Store for 365 days
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 365);

  let tableData = {};

  // Try to read existing table-specific cookie
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${tableName}=`));

  if (cookie) {
    try {
      const value = decodeURIComponent(cookie.split("=")[1]);
      tableData = JSON.parse(value);
    } catch (err) {
      console.error("Error parsing existing cookie data:", err);
      tableData = {};
    }
  }

  // Update the specific column width
  tableData[columnKey] = width;

  // Save updated object back to cookie
  document.cookie = `${tableName}=${encodeURIComponent(
    JSON.stringify(tableData)
  )};expires=${expiryDate.toUTCString()};path=/`;
};

export function setCookie(name, value, days = 365) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  const cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )};expires=${expires.toUTCString()};path=/`;
  document.cookie = cookieString;
}

export function getCookie(name) {
  const nameEQ = `${encodeURIComponent(name)}=`;
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
}
